import React from 'react';
import { Layout } from 'antd';
import style from './SidebarLayout.module.scss';
import { useLocation } from 'react-router-dom';
const { Content } = Layout;

const SidebarHeaderLayout = ({children}) => {
  let location = useLocation() as any;
  if(location?.pathname === '/') return children;

  return (
      <Layout className={style.section}>
        <Content
          className={style.content}
        >{children}</Content>
      </Layout>
  )
}

export default SidebarHeaderLayout;